import { render, staticRenderFns } from "./MasterDataTable.vue?vue&type=template&id=2a177808&scoped=true"
import script from "./MasterDataTable.vue?vue&type=script&lang=js"
export * from "./MasterDataTable.vue?vue&type=script&lang=js"
import style0 from "./MasterDataTable.vue?vue&type=style&index=0&id=2a177808&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a177808",
  null
  
)

export default component.exports